const breadCrumb =
  "Lotação de Servidores - Consultas de Informações do Servidor";

const routes = [
  {
    path: "/consulta-de-servidor-nao-lotado",
    name: "consulta-de-servidor-nao-lotado",
    meta: {
      allowedPermissions: ["servidor_nao_lotado_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaDeServidorNaoLotado/ConsultaDeServidorNaoLotadoHome.vue"
      ),
  },
];

export default routes;
